/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './RecommendSection.module.scss';
import ControlPanelBackground from './control-panel-background.svg';

const RecommendSection: PageComponent = () => {
    const recommendsMax = 5;
    const [acitvePlan, setActivePlan] = useState(0);
    const prevActivePlan = () => {
        let index = acitvePlan;
        if (index < 1) {
            index = recommendsMax;
        } else {
            index -= 1;
        }
        setActivePlan(index);
    };
    const nextActivePlan = () => {
        let index = acitvePlan;
        if (index === recommendsMax) {
            index = 0;
        } else {
            index += 1;
        }
        setActivePlan(index);
    };
    return (
        <section className={styles.section}>
            <h1 className={styles.title}>
                <Trans
                    i18nKey="recommendation.title"
                    ns="landingInformationLoyalty"
                >
                    Rekomendavimo Sistema
                </Trans>
            </h1>
            <p className={styles.desc}>
                <Trans
                    i18nKey="recommendation.description"
                    ns="landingInformationLoyalty"
                >
                    Si sistema skirta norintiems uzsidirbti is musu paslaugu
                    rekomendavimo kitiems.
                </Trans>
            </p>

            <p className={styles.extra_desc}>
                <Trans
                    i18nKey="recommendation.extra_desc"
                    ns="landingInformationLoyalty"
                >
                    Gaunama dalis už kiekvieną mėnesį nuo 100 Eur.
                </Trans>
            </p>

            <div className={styles.r_content}>
                <div className={`container ${styles.r_container}`}>
                    <ControlPanelBackground className={styles.left_shape} />
                    <div className={styles.r_container_containt}>
                        <div className={styles.r_containt}>
                            <div
                                className={classNames(styles.r_inner, {
                                    [styles.active]: acitvePlan === 0,
                                })}
                            >
                                <span
                                    className={styles.prev}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        prevActivePlan();
                                    }}
                                />
                                <span
                                    className={styles.next}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextActivePlan();
                                    }}
                                />
                                <div>
                                    <Trans
                                        i18nKey="recommendation.rewards.first"
                                        ns="landingInformationLoyalty"
                                    >
                                        <p>1 mėnesis</p>
                                        <span>15 EUR</span>
                                        <p>(15%)</p>
                                    </Trans>
                                </div>
                            </div>
                            <div
                                className={classNames(styles.r_inner, {
                                    [styles.active]: acitvePlan === 1,
                                })}
                            >
                                <span
                                    className={styles.prev}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        prevActivePlan();
                                    }}
                                />
                                <span
                                    className={styles.next}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextActivePlan();
                                    }}
                                />
                                <div>
                                    <Trans
                                        i18nKey="recommendation.rewards.second"
                                        ns="landingInformationLoyalty"
                                    >
                                        <p>2 mėnesis</p>
                                        <span>15 EUR</span>
                                        <p>(15%)</p>
                                    </Trans>
                                </div>
                            </div>
                            <div
                                className={classNames(styles.r_inner, {
                                    [styles.active]: acitvePlan === 2,
                                })}
                            >
                                <span
                                    className={styles.prev}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        prevActivePlan();
                                    }}
                                />
                                <span
                                    className={styles.next}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextActivePlan();
                                    }}
                                />
                                <div>
                                    <Trans
                                        i18nKey="recommendation.rewards.third"
                                        ns="landingInformationLoyalty"
                                    >
                                        <p>3 mėnesis</p>
                                        <span>15 EUR</span>
                                        <p>(15%)</p>
                                    </Trans>
                                </div>
                            </div>
                        </div>

                        <div className={styles.r_containt}>
                            <div
                                className={classNames(styles.r_inner, {
                                    [styles.active]: acitvePlan === 3,
                                })}
                            >
                                <span
                                    className={styles.prev}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        prevActivePlan();
                                    }}
                                />
                                <span
                                    className={styles.next}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextActivePlan();
                                    }}
                                />
                                <div>
                                    <Trans
                                        i18nKey="recommendation.rewards.fourth"
                                        ns="landingInformationLoyalty"
                                    >
                                        <p>4 mėnesis</p>
                                        <span>15 EUR</span>
                                        <p>(15%)</p>
                                    </Trans>
                                </div>
                            </div>
                            <div
                                className={classNames(styles.r_inner, {
                                    [styles.active]: acitvePlan === 4,
                                })}
                            >
                                <span
                                    className={styles.prev}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        prevActivePlan();
                                    }}
                                />
                                <span
                                    className={styles.next}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextActivePlan();
                                    }}
                                />
                                <div>
                                    <Trans
                                        i18nKey="recommendation.rewards.fifth"
                                        ns="landingInformationLoyalty"
                                    >
                                        <p>5 mėnesis</p>
                                        <span>15 EUR</span>
                                        <p>(15%)</p>
                                    </Trans>
                                </div>
                            </div>
                            <div
                                className={classNames(styles.r_inner, {
                                    [styles.active]: acitvePlan === 5,
                                })}
                            >
                                <span
                                    className={styles.prev}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        prevActivePlan();
                                    }}
                                />
                                <span
                                    className={styles.next}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextActivePlan();
                                    }}
                                />
                                <div>
                                    <Trans
                                        i18nKey="recommendation.rewards.sixth"
                                        ns="landingInformationLoyalty"
                                    >
                                        <p>6 mėnesis</p>
                                        <span>15 EUR</span>
                                        <p>(15%)</p>
                                    </Trans>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ControlPanelBackground className={styles.right_shape} />
                </div>

                <p className={styles.extra_info}>
                    <Trans
                        i18nKey="recommendation.text"
                        ns="landingInformationLoyalty"
                    >
                        Galite įkelti pageidaujamo dydžio logotipą/banerį ar
                        tiesiog nuorodą į Jūsų projektą ir jeigu per šią nuorodą
                        atėjęs asmuo apmoka paslaugą, Jums į balansą atiteks 15%
                        to kliento sumokėtų pinigų. Iš atvesto kliento galite
                        uždirbti iki pusės metų laikotarpio jo sumokėtų pinigų
                        "makro" (banku, maxima ir t.t.) būdais.
                    </Trans>
                </p>
            </div>
        </section>
    );
};

export default RecommendSection;
